export const addThemeModal = {
  extend: '/add-global-theme-modal',
  props: {
    onSubmit: (e, el, s) => {
      e.preventDefault()
      const {
        value,
        themeModifier
      } = s
      if (themeModifier && value) {
        const sceneTheme = el.getRootState().sceneTheme
        const globalTheme = '@' + sceneTheme

        const inversedKey = globalTheme === '@dark' ? '@light' : '@dark'
        const inversedValue = {
          color: value.background,
          background: value.color
        }
        el.updateDesignSystem({
          theme: {
            [themeModifier]: {
              [globalTheme]: value,
              [inversedKey]: inversedValue
            }
          }
        })
        el.call('closeRouterModal', el, s)
      }
    },
  },
  ModalHeader: {
    title: 'Add a new theme',
    p: null,
  },
};